// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image_wrapper__3mWGt","img":"Image_img__2QxuA","imgGroup":"Image_imgGroup__3m1kY","imgBlock":"Image_imgBlock__2-j4f","imgBlockGrid":"Image_imgBlockGrid__qjHpe"};